import Rellax from 'rellax';

const initBlock = () => {
    if (window.innerWidth > 1200) {
        const rellax = new Rellax('.js-parallax-cards');
    }
};

document.addEventListener('DOMContentLoaded', initBlock, false)